import { CardMedia, Stack, Typography } from '@mui/material';
import { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import AvatarImage from 'src/assets/images/avatar.png';
import { routesForOwnerOperator } from 'src/routes';
import { SB_API_URL } from 'src/utils/environment';

import { getTitleFromRoutes } from './TopBar.helper';
import { Avatar, TopBarWrapper } from './TopBar.styles';

export const TopBar = () => {
  const location = useLocation();

  const pageTitle = useMemo(() => {
    const title = getTitleFromRoutes(location.pathname, routesForOwnerOperator);

    return title || 'Locations';
  }, [location.pathname]);

  return (
    <TopBarWrapper>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ width: '100%' }}>
        <Typography variant="h2" component="h2" sx={{ fontWeight: 600 }}>
          {pageTitle}
        </Typography>
        <Link to={SB_API_URL} target="_blank">
          <Avatar>
            <CardMedia component="img" image={AvatarImage} />
          </Avatar>
        </Link>
      </Stack>
    </TopBarWrapper>
  );
};
